const map = {
  AlipayAccountConfigurationList: () => import('@/views/fundManagement/alipayAccountConfiguration/index'),
  TemporaryReceiptsList: () => import('@/views/fundManagement/temporaryReceipts/index')
}
export default map